import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ReferralDashboardPage from '@/pages/intake/ReferralDashboardPage';
import ParticipantIntakeListPage from '@/pages/intake/ParticipantIntakeListPage';

// Referrals and Participant Intake as one module. Each tab keeps its own URL (/intake/referrals, /intake/participants)
// so existing links and quick actions still land on the right tab; a tab shows only with its permission.
const TABS = [
  { key: 'referrals', label: 'Referrals', path: '/intake/referrals', permissions: ['participants.view', 'participants.manage'], Page: ReferralDashboardPage },
  { key: 'intake', label: 'Participant Intake', path: '/intake/participants', permissions: ['intake.view'], Page: ParticipantIntakeListPage },
];

export default function IntakeHubPage({ tab }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const visible = TABS.filter(t => t.permissions.some(p => hasPermission(p)));
  const active = visible.find(t => t.key === tab) || visible[0] || TABS.find(t => t.key === tab);
  const { Page } = active;

  return (
    <div className="space-y-4" data-testid="intake-hub">
      {visible.length > 1 && (
        <Tabs value={active.key} onValueChange={key => navigate(TABS.find(t => t.key === key).path)}>
          <TabsList>
            {visible.map(t => <TabsTrigger key={t.key} value={t.key} data-testid={`intake-hub-tab-${t.key}`}>{t.label}</TabsTrigger>)}
          </TabsList>
        </Tabs>
      )}
      <Page />
    </div>
  );
}
